import { useCallback } from 'react';

import { TServerSendRequest } from '../../types';
import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useGetPlayerSelfExclusion = () => {
    const send = useGenericSend();

    return useCallback(async (): Promise<Types.IGetPlayerSelfExclusionResponseData> => {
        const { data } = await send<TServerSendRequest, Types.IGetPlayerSelfExclusionResponseData>({
            ID: 35601,
            responses: [35602, 35603],
            description: 'Get player self-exclusion',
            errorLevel: 1
        });

        return data;
    }, [
        send
    ]);
};
